const url = '/api/v1/gradebook/';

export const state = {
    groupData: [],
    programs: [],
    modules: [],
    teachers: [],
    groupScheduleTypes: [],
    packages: null,
    modalEditGroup: false,
}, modules = {
    loading: 'loading', alert: 'alert', gradebook: 'gradebook',
}

export const getters = {
    groupData: state => state.groupData,
    studentData: state => state.studentData,
    programs: state => state.programs,
    modules: state => state.modules,
    teachers: state => state.teachers,
    groupScheduleTypes: state => state.groupScheduleTypes,
    packages: state => state.packages,
    modalEditGroup: state => state.modalEditGroup,
}

export const mutations = {
    setData(state, {type, items}) {
        state[type] = items;
    },

    clearData(state, {types}) {
        for (let key in state) {
            for (let type in types) {
                key === types[type] ? state[key] = null : false
            }
        }
    }
}

export const actions = {

    async getPackages({commit, dispatch}) {
        dispatch('loading/addLoading', '', {root: true})
        const { data: items } = await axios.get(url + 'get-packages');
        dispatch('loading/subLoading', '', {root: true})

        commit('setData', {type: 'packages', items: items});
    },

    async getProgramsByPartner({commit, state, dispatch}, item) {
        if (item && item.id) {
            dispatch('loading/addLoading', '', {root: true})
            const {data: items} = await axios.get(url + 'get-programs-by-partner/' + item.id);
            dispatch('loading/subLoading', '', {root: true})

            commit('setData', {type: 'programs', items: items});
        } else {
            commit("clearData", {types: ['programs', 'modules']});
        }
    },

    async getModulesByProgram({commit, state, dispatch}, item) {
        if (item && item.id) {
            dispatch('loading/addLoading', '', {root: true})
            const {data: items} = await axios.get(url + 'get-modules-by-program/' + item.id);
            dispatch('loading/subLoading', '', {root: true})

            commit('setData', {type: 'modules', items: items});
        } else {
            commit("clearData", {types: ['modules']});
        }
    },

    async getTeachersByPartner({commit, state, dispatch}, item) {
        if (item && item.id) {
            dispatch('loading/addLoading', '', {root: true})
            const {data: items} = await axios.get(url + 'get-teachers-by-partner/' + item.id);
            dispatch('loading/subLoading', '', {root: true})

            commit('setData', {type: 'teachers', items: items});
        } else {
            commit("clearData", {types: ['modules']});
        }
    },

    async getGroupScheduleTypes({commit, dispatch}) {
        dispatch('loading/addLoading', '', {root: true})
        const {data: items} = await axios.get(url + 'get-group-schedule-types');
        commit('setData', {type: 'groupScheduleTypes', items: items});
        dispatch('loading/subLoading', '', {root: true})
    },

    // edit group
    async showModalEditGroup({commit, state, dispatch}, id = null) {
        commit('setData', {type: 'groupData', items: null});

        if (id) {
            dispatch('loading/addLoading', '', {root: true})
            const {data: {groupData}} = await axios.get(url + 'get-full-group-data', {
                params: {
                    'group_id': id
                }
            });
            dispatch('loading/subLoading', '', {root: true})

            commit('setData', {type: 'groupData', items: groupData});
        }

        commit('setData', {type: 'modalEditGroup', items: true});
    },

    async saveGroup({commit, state, dispatch}, params) {
        try {
            dispatch('loading/addLoading', '', {root: true})

            await axios.post(url + 'save-group', params);

            commit('setData', {type: 'modalEditGroup', items: false});
            dispatch('gradebook/clearAllData', '', {root: true})
        } catch (err) {
            console.log(err)
        } finally {
            dispatch('loading/subLoading', '', {root: true})
        }
    },
    // end edit group

    hideModal({commit, state, dispatch}, modal) {
        commit('setData', {type: modal, items: false});
    },

    // end modals
};